import React from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { DefaultButton, LoadingButton } from '../buttons';
import { TextField, Select, Checkbox, OrderTypeSelector } from '../fields';
import { ModalLayout } from '../layouts';
import { PromoService } from '../../services';
import { Toast } from '../alerts';

import '../../styles/modals/modal.css';
import '../../styles/modals/savepromo.css';

class SavePromoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.initialState();

    this.show = this.show.bind(this);
    this.setFields = this.setFields.bind(this);
    this.onSaveBtnClick = this.onSaveBtnClick.bind(this);
    this.onBuyProductChange = this.onBuyProductChange.bind(this);
    this.onFreeProductChange = this.onFreeProductChange.bind(this);
    this.onSelectedBuyProductChange = this.onSelectedBuyProductChange.bind(this);
    this.onSelectedFreeProductChange = this.onSelectedFreeProductChange.bind(this);

    this.promoService = new PromoService();
  }

  initialState() {
    return {
      show: false,
      loading: false,
      promoId: null,
      venue: null,

      name: '',
      isActive: true,

      buyQty: '2',
      buyMode: 'CATEGORY',
      buyCategory: null,
      buyProducts: [],
      selectedBuyProducts: [],

      freeQty: '1',
      freeMode: 'CATEGORY',
      freeCategory: null,
      freeProducts: [],
      selectedFreeProducts: [],

      startDate: moment().toDate(),
      endDate: moment('2099-12-31T23:59:59').toDate(),
      orderTypes: [],

      error: null,
    };
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  show(set = true, venue = null) {
    this.setState({
      ...this.initialState(),
      show: set,
      venue,
    });
  }

  setFields(promo, venue = null) {
    const trigger = promo.trigger || {};
    const reward = promo.reward || {};
    const conditions = promo.conditions || {};

    const buyCategory =
      trigger.category_id && typeof trigger.category_id === 'object'
        ? trigger.category_id
        : null;

    const freeCategory =
      reward.category_id && typeof reward.category_id === 'object'
        ? reward.category_id
        : null;

    const buyProductObjects = Array.isArray(conditions.product_ids)
      ? conditions.product_ids.filter(
          (product) => product && typeof product === 'object'
        )
      : [];

    const freeProductObjects = Array.isArray(reward.product_ids)
      ? reward.product_ids.filter(
          (product) => product && typeof product === 'object'
        )
      : [];

    let buyMode = 'CATEGORY';

    if (
      trigger.type === 'MIN_QTY' &&
      conditions.scope === 'PRODUCTS' &&
      Array.isArray(conditions.product_ids) &&
      conditions.product_ids.length > 0
    ) {
      buyMode = 'PRODUCTS';
    }

    let freeMode = 'CATEGORY';

    if (
      Array.isArray(reward.product_ids) &&
      reward.product_ids.length > 0
    ) {
      freeMode = 'PRODUCTS';
    }

    this.setState({
      promoId: promo._id,
      venue: promo.venue || venue || this.state.venue,
      name: promo.name || '',
      isActive: promo.is_active !== false,

      buyQty:
        trigger.min_qty != null
          ? String(trigger.min_qty)
          : reward.buy_qty != null
          ? String(reward.buy_qty)
          : '2',

      buyMode,
      buyCategory,
      buyProducts: buyProductObjects,
      selectedBuyProducts:
        buyMode === 'PRODUCTS'
          ? (conditions.product_ids || []).map((id) =>
              typeof id === 'object' ? id._id.toString() : id.toString()
            )
          : [],

      freeQty:
        reward.max_qty != null
          ? String(reward.max_qty)
          : reward.get_qty != null
          ? String(reward.get_qty)
          : '1',

      freeMode,
      freeCategory,
      freeProducts: freeProductObjects,
      selectedFreeProducts:
        freeMode === 'PRODUCTS'
          ? (reward.product_ids || []).map((id) =>
              typeof id === 'object' ? id._id.toString() : id.toString()
            )
          : [],

      startDate: promo.start_date
        ? moment(promo.start_date).toDate()
        : moment().toDate(),

      endDate: promo.end_date
        ? moment(promo.end_date).toDate()
        : moment('2099-12-31T23:59:59').toDate(),
      orderTypes: Array.isArray(promo.order_types) ? promo.order_types : [],

      error: null,
    });
  }

  onBuyProductChange(product) {
    const id = product._id.toString();

    if (!this.state.selectedBuyProducts.includes(id)) {
      this.setState({
        buyProducts: [...this.state.buyProducts, product],
        selectedBuyProducts: [...this.state.selectedBuyProducts, id],
      });
    }
  }

  onFreeProductChange(product) {
    const id = product._id.toString();

    if (!this.state.selectedFreeProducts.includes(id)) {
      this.setState({
        freeProducts: [...this.state.freeProducts, product],
        selectedFreeProducts: [...this.state.selectedFreeProducts, id],
      });
    }
  }

  onSelectedBuyProductChange(checked, value) {
    if (checked) {
      if (!this.state.selectedBuyProducts.includes(value)) {
        this.setState({
          selectedBuyProducts: [...this.state.selectedBuyProducts, value],
        });
      }
      return;
    }

    this.setState({
      selectedBuyProducts: this.state.selectedBuyProducts.filter(
        (id) => id !== value
      ),
    });
  }

  onSelectedFreeProductChange(checked, value) {
    if (checked) {
      if (!this.state.selectedFreeProducts.includes(value)) {
        this.setState({
          selectedFreeProducts: [...this.state.selectedFreeProducts, value],
        });
      }
      return;
    }

    this.setState({
      selectedFreeProducts: this.state.selectedFreeProducts.filter(
        (id) => id !== value
      ),
    });
  }

  validate() {
    const s = this.state;

    if (!s.venue || !s.venue._id) {
      return 'Venue is required.';
    }

    if (!s.name.trim()) {
      return 'Promotion name is required.';
    }

    if (!s.orderTypes || s.orderTypes.length === 0) {
      return 'Select at least one order method.';
    }

    if (!Number.isInteger(Number(s.buyQty)) || Number(s.buyQty) < 1) {
      return 'Buy quantity must be at least 1.';
    }

    if (!Number.isInteger(Number(s.freeQty)) || Number(s.freeQty) < 1) {
      return 'Free quantity must be at least 1.';
    }

    if (s.buyMode === 'CATEGORY' && !s.buyCategory) {
      return 'Choose a qualifying category.';
    }

    if (
      s.buyMode === 'PRODUCTS' &&
      s.selectedBuyProducts.length === 0
    ) {
      return 'Choose at least one qualifying product.';
    }

    if (s.freeMode === 'CATEGORY' && !s.freeCategory) {
      return 'Choose a free-item category.';
    }

    if (
      s.freeMode === 'PRODUCTS' &&
      s.selectedFreeProducts.length === 0
    ) {
      return 'Choose at least one free product.';
    }

    return null;
  }

  buildPayload() {
    const s = this.state;

    const buyCategoryId =
      s.buyMode === 'CATEGORY' && s.buyCategory
        ? s.buyCategory._id
        : null;

    const freeCategoryId =
      s.freeMode === 'CATEGORY' && s.freeCategory
        ? s.freeCategory._id
        : null;

    return {
      venue_id: s.venue._id,
      name: s.name.trim(),
      description: '',
      is_active: s.isActive,
      priority: 100,

      activation_type: 'AUTO',
      code: null,

      start_date: moment(s.startDate).toISOString(),
      end_date: moment(s.endDate).toISOString(),

      schedule: {
        days: [],
        start_time: null,
        end_time: null,
      },

      order_types: this.state.orderTypes,

      customer_rules: {
        first_order_only: false,
        membership_ids: [],
      },

      conditions: {
        min_spend: null,
        min_qty:
          s.buyMode === 'PRODUCTS' ? Number(s.buyQty) : null,
        scope: s.buyMode === 'PRODUCTS' ? 'PRODUCTS' : 'CATEGORIES',
        product_ids:
          s.buyMode === 'PRODUCTS' ? s.selectedBuyProducts : [],
        category_ids:
          s.buyMode === 'CATEGORY' && buyCategoryId
            ? [buyCategoryId]
            : [],
        excluded_product_ids: [],
        excluded_category_ids: [],
      },

      trigger: {
        type:
          s.buyMode === 'CATEGORY'
            ? 'CATEGORY_QTY'
            : 'MIN_QTY',
        category_id: buyCategoryId,
        product_id: null,
        min_qty: Number(s.buyQty),
        min_spend: null,
      },

      reward: {
        type: 'FREE_ITEM',
        percent: null,
        fixed_amount: null,
        category_id: freeCategoryId,
        product_id: null,
        product_ids:
          s.freeMode === 'PRODUCTS' ? s.selectedFreeProducts : [],
        category_ids:
          s.freeMode === 'CATEGORY' && freeCategoryId
            ? [freeCategoryId]
            : [],
        buy_qty: Number(s.buyQty),
        get_qty: Number(s.freeQty),
        max_qty: Number(s.freeQty),
        max_discount: null,
        cheapest_item_only: true,
      },

      usage: {
        max_total_uses: null,
        max_uses_per_customer: null,
      },

      stacking: {
        allow_with_discounts: true,
        allow_with_promos: false,
        exclusive: true,
      },
    };
  }

  async onSaveBtnClick() {
    const error = this.validate();

    if (error) {
      this.setState({ error });
      return;
    }

    this.setState({
      loading: true,
      error: null,
    });

    try {
      const payload = this.buildPayload();

      const result = this.state.promoId
        ? await this.promoService.put({
            ...payload,
            promo_id: this.state.promoId,
          })
        : await this.promoService.post(payload);

      if (result && result.success) {
        Toast.success(this.state.promoId ? 'Updated' : 'Saved');
        this.show(false);

        if (this.props.onComplete) {
          this.props.onComplete();
        }

        return;
      }

      this.setState({
        error:
          result && result.message
            ? result.message
            : 'Unable to save promotion.',
      });
    } catch (error) {
      this.setState({
        error:
          error && error.message
            ? error.message
            : 'Unable to save promotion.',
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  renderProductChoices(products, selectedProducts, onChange) {
    return products.map((product) => (
      <div key={product._id} className='promo-product-choice'>
        <Checkbox
          text={product.name}
          value={product._id.toString()}
          checked={selectedProducts.includes(product._id.toString())}
          onChange={onChange}
        />
      </div>
    ));
  }

  render() {
    const {
      show,
      loading,
      venue,
      name,
      isActive,
      buyQty,
      buyMode,
      buyCategory,
      buyProducts,
      selectedBuyProducts,
      freeQty,
      freeMode,
      freeCategory,
      freeProducts,
      selectedFreeProducts,
      error,
    } = this.state;

    if (!show) {
      return null;
    }

    const venueQuery = venue ? { venue_id: venue._id } : {};

    return (
      <ModalLayout
        show={show}
        title={this.state.promoId ? 'Edit Promotion' : 'Add Promotion'}
        onHide={() => this.show(false)}
      >
        <div className='save-promo-simple'>
          <div className='promo-simple-section'>
            <TextField
              label='Promotion Name'
              value={name}
              fullWidth
              onChange={(e) => this.setState({ name: e.target.value })}
            />

            <div className='promo-active-row'>
              <Checkbox
                text='Active'
                checked={isActive}
                onChange={(checked) =>
                  this.setState({ isActive: checked })
                }
              />
            </div>
          </div>

          <div className='promo-simple-section'>
            <h4>Order Methods</h4>
            <OrderTypeSelector
              selected={this.state.orderTypes}
              onChange={(types) => this.setState({ orderTypes: types })}
              error={!!this.state.error && this.state.orderTypes.length === 0}
              errorText={'Select at least one order method.'}
            />
          </div>



          <div className='promo-simple-section'>
            <h4>Buy</h4>

            <Row>
              <Col xs={12} md={4}>
                <TextField
                  label='Quantity'
                  type='number'
                  value={buyQty}
                  fullWidth
                  onChange={(e) =>
                    this.setState({ buyQty: e.target.value })
                  }
                />
              </Col>
            </Row>

            <div className='promo-choice-heading'>
              Qualifying products
            </div>

            <div className='promo-mode-row'>
              <Checkbox
                text='Category'
                value='CATEGORY'
                checked={buyMode === 'CATEGORY'}
                onChange={(checked) => {
                  if (checked) {
                    this.setState({
                      buyMode: 'CATEGORY',
                      selectedBuyProducts: [],
                    });
                  }
                }}
              />

              <Checkbox
                text='Individual items'
                value='PRODUCTS'
                checked={buyMode === 'PRODUCTS'}
                onChange={(checked) => {
                  if (checked) {
                    this.setState({
                      buyMode: 'PRODUCTS',
                      buyCategory: null,
                    });
                  }
                }}
              />
            </div>

            {buyMode === 'CATEGORY' && (
              <Select
                type='product_categories'
                method='get'
                field='name'
                label='Category'
                fullWidth
                query={venueQuery}
                defaultValue={buyCategory}
                onChange={(value) =>
                  this.setState({ buyCategory: value })
                }
              />
            )}

            {buyMode === 'PRODUCTS' && (
              <React.Fragment>
                <Select
                  type='products'
                  method='get'
                  field='name'
                  label='Select Product'
                  fullWidth
                  query={venueQuery}
                  onChange={this.onBuyProductChange}
                />

                <div className='promo-selected-products'>
                  {this.renderProductChoices(
                    buyProducts,
                    selectedBuyProducts,
                    this.onSelectedBuyProductChange
                  )}
                </div>
              </React.Fragment>
            )}
          </div>

          <div className='promo-simple-section'>
            <h4>Get free</h4>

            <Row>
              <Col xs={12} md={4}>
                <TextField
                  label='Quantity'
                  type='number'
                  value={freeQty}
                  fullWidth
                  onChange={(e) =>
                    this.setState({ freeQty: e.target.value })
                  }
                />
              </Col>
            </Row>

            <div className='promo-choice-heading'>
              Free products
            </div>

            <div className='promo-mode-row'>
              <Checkbox
                text='Category'
                value='CATEGORY'
                checked={freeMode === 'CATEGORY'}
                onChange={(checked) => {
                  if (checked) {
                    this.setState({
                      freeMode: 'CATEGORY',
                      selectedFreeProducts: [],
                    });
                  }
                }}
              />

              <Checkbox
                text='Individual items'
                value='PRODUCTS'
                checked={freeMode === 'PRODUCTS'}
                onChange={(checked) => {
                  if (checked) {
                    this.setState({
                      freeMode: 'PRODUCTS',
                      freeCategory: null,
                    });
                  }
                }}
              />
            </div>

            {freeMode === 'CATEGORY' && (
              <Select
                type='product_categories'
                method='get'
                field='name'
                label='Category'
                fullWidth
                query={venueQuery}
                defaultValue={freeCategory}
                onChange={(value) =>
                  this.setState({ freeCategory: value })
                }
              />
            )}

            {freeMode === 'PRODUCTS' && (
              <React.Fragment>
                <Select
                  type='products'
                  method='get'
                  field='name'
                  label='Select Product'
                  fullWidth
                  query={venueQuery}
                  onChange={this.onFreeProductChange}
                />

                <div className='promo-selected-products'>
                  {this.renderProductChoices(
                    freeProducts,
                    selectedFreeProducts,
                    this.onSelectedFreeProductChange
                  )}
                </div>
              </React.Fragment>
            )}
          </div>

          {error && <div className='outlined-textfield-error-text'>
              {error}
            </div>}

          <div className='promo-simple-actions'>
            <DefaultButton
              text='Cancel'
              onClick={() => this.show(false)}
            />

            <LoadingButton
              text='Save Promotion'
              loading={loading}
              onClick={this.onSaveBtnClick}
            />
          </div>
        </div>
      </ModalLayout>
    );
  }
}

export default withTranslation()(SavePromoModal);
